import { render, staticRenderFns } from "./ErrorComponent.vue?vue&type=template&id=6abc2016"
import script from "./ErrorComponent.vue?vue&type=script&lang=js"
export * from "./ErrorComponent.vue?vue&type=script&lang=js"
import style0 from "./ErrorComponent.vue?vue&type=style&index=0&id=6abc2016&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports